import React,{useState} from 'react';
import { IoIosNotifications } from "react-icons/io";
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import AddPetDetails from '../AddPetDetails';
const Notification = (props) => {
    
    const getCurrentGreeting = () => {
        const currentHour = new Date().getHours();
        if (currentHour < 12) {
            return "Good Morning";
        } else if (currentHour < 18) {
            return "Good Afternoon";
        } else {
            return "Good Evening";
        }
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
      setIsModalOpen(false);
      
    };
  
    return (
        <div className=' md:block hidden'>
            <div className='font-bold text-xl pb-2'>
                <h1>{getCurrentGreeting()}</h1>
            </div>
            <div className="md:p-4 p-2 bg-red-100 rounded shadow-md text-red-600  items-center">
                <div className="flex   items-center">
                    <IoIosNotifications className="fill-[#FF0000] text-xl"/>
                    <h1 className="text-[#000] text-xl font-bold">Notification</h1>
                </div>
                <div className="p-4 text-[#000] text-[15px]">
                {props.completion<100?<p>Please complete your profile. <Link to="/editprofile" className="text-[#403DC4] font-bold">Update <FaArrowRightLong className="inline-flex"/></Link></p>:""}
                {props.petdata<1?<p>Add pet profile. <Link  className="text-[#403DC4]  font-bold" onClick={openModal}>Add Pet <FaArrowRightLong className="inline-flex"/></Link></p>:""}
                {isModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
                      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl h-4/5 overflow-y-auto">
                        
                        <AddPetDetails onClose={closeModal} />
                      </div>
                    </div>
                  )}
                  {props.confirmed>0?
                    <p>You have {props.confirmed} confirmed {props.confirmed=="1"?"booking":"bookings"}. <Link to="/scheduling" className="text-[#403DC4] font-bold">Check Here <FaArrowRightLong className="inline-flex"/></Link></p>:""
                  }
                  {props.upcoming>0?
                    <p>You have {props.upcoming} upcoming {props.upcoming=="1"?"booking":"bookings"}. <Link to="/scheduling" className="text-[#403DC4] font-bold">Check Here <FaArrowRightLong className="inline-flex"/></Link></p>:""
                  }
            </div>
            </div>
           
           
        </div>
    );
}

export default Notification;
